import * as React from 'react'

import { Box, BoxProps } from './Box'

export function HRule(props:BoxProps) {
  return <Box width='100%' height='1px' bg='border' {...props} />;
}
